// extracted by mini-css-extract-plugin
module.exports = {"root":"TenantEmail_root__UvhSS","content":"TenantEmail_content__34fEw","secondaryContent":"TenantEmail_secondaryContent__3K0Ro"};